import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a5341b3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "total-text"
};
const _hoisted_2 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px",
    "flex": "1 0 0"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_number_value = _resolveComponent("number-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, field => {
    return _openBlock(), _createBlock(_component_b_td, {
      key: field.key,
      class: _normalizeClass([{
        ['b-table-sticky-column']: $options.isTotalColumn(field) || field.key === 'estimated_opportunity'
      }, {
        ['right']: field.key === 'estimated_opportunity'
      }])
    }, {
      default: _withCtx(() => [_createVNode(_component_hug_value, {
        class: "total-element",
        styles: {
          justifyContent: $options.getJustify(field),
          padding: '8px'
        },
        loading: $props.loading
      }, {
        default: _withCtx(() => [$options.isTotalColumn(field) ? (_openBlock(), _createElementBlock("span", _hoisted_1, "TOTAL")) : _createCommentVNode("", true), field.key === 'search_query_volume' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 1,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`search_query_volume_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.search_query_volume
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'seller_notoriety' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 2,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`seller_notoriety_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.seller_notoriety
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'search_revenue_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 3,
          gap: 16
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: $props.total?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] * 100
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              charCount: _ctx.minMax?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? _ctx.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`] + 2 : _ctx.maxCharCount?.percentage?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              precision: Math.abs($props.total?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs($props.total?.[`search_revenue_share_evol${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
              showSign: "",
              pp: "",
              tight: ""
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 1
          }, 8, ["value"])]),
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_percentage_value, {
            value: $props.total?.search_revenue_share,
            charCount: _ctx.maxCharCount?.percentage?.search_revenue_share + 2,
            tight: "",
            precision: 1
          }, null, 8, ["value", "charCount"]), _createVNode(_component_currency_value, {
            value: $props.total?.search_revenue,
            color: "#999"
          }, null, 8, ["value"])])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'impression_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 4,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`impression_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.total.impression_share,
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'impression_count' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 5,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`impression_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.impression_count
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'click_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 6,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`click_share_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`click_share_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`click_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.total.click_share,
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'click_count' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 7,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`click_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.click_count,
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'purchase_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 8,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: "",
              pp: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.total.purchase_share,
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'purchase_count' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 9,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`purchase_count_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.purchase_count,
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'brand_ctr' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 10,
          value: $props.total?.ctr,
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'conversion_rate' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 11,
          value: $props.total?.conversion_rate,
          precision: 1
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'top_product' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 12
        }, [], 64)) : _createCommentVNode("", true), field.key === 'sf_share_of_voice' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 13
        }, _renderList(['top_1_share_of_voice', 'top_3_share_of_voice', 'top_10_share_of_voice'], element => {
          return _createVNode(_component_hug_value, {
            loading: $props.loading,
            style: {
              "padding": "0px 8px"
            },
            class: "sf-share-of-voice-subelts"
          }, {
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: $props.total?.[element],
              charCount: _ctx.maxCharCount?.percentage?.[element],
              styles: {
                justifyContent: 'flex-end',
                width: '100%'
              },
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["loading"]);
        }), 64)) : _createCommentVNode("", true), field.key === 'sf_best_position' ? (_openBlock(), _createBlock(_component_flex_row, {
          key: 14,
          gap: 6,
          style: {
            "justify-content": "space-between",
            "align-items": "center",
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total?.best_organic_position,
            precision: 0,
            tight: "",
            prepend: "#"
          }, null, 8, ["value"]), _createVNode(_component_number_value, {
            value: $props.total?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
            color: $props.total?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`] < 0 ? '#E7747A' : '#22863D',
            charCount: _ctx.maxCharCount?.number?.[`best_organic_position_evol${$data.evolCategory[_ctx.periodCategory]}`],
            showSign: "",
            align: "right",
            tight: ""
          }, null, 8, ["value", "color", "charCount"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'sov_sponsored' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 15,
          value: $props.total?.share_of_voice_sponsored,
          charCount: _ctx.maxCharCount?.percentage?.share_of_voice_sponsored,
          styles: {
            justifyContent: 'flex-end',
            width: '100%'
          },
          tight: ""
        }, null, 8, ["value", "charCount"])) : _createCommentVNode("", true), field.key === 'no_impressions_per_search' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 16
        }, [], 64)) : _createCommentVNode("", true), field.key === 'sf_click_share' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 17
        }, [], 64)) : _createCommentVNode("", true), field.key === 'estimated_opportunity' ? (_openBlock(), _createBlock(_component_hug_value, {
          key: 18,
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total?.missed_opportunities,
            color: "#4D4D4D",
            style: {
              "font-size": "14px"
            },
            showSign: "",
            align: "right"
          }, null, 8, ["value"])]),
          _: 1
        }, 8, ["loading"])) : _createCommentVNode("", true), field.key === 'purchases_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 19,
          gap: 16
        }, {
          evolution: _withCtx(() => [$props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`purchase_share_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              pp: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: $props.total?.purchase_share,
            styles: {
              justifyContent: 'flex-start'
            }
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["styles", "loading"])]),
      _: 2
    }, 1032, ["class"]);
  }), 128);
}